import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { initials } from '@/lib/format'

export function Person({ name, email, uid }: { name?: string; email?: string; uid?: string }) {
  const known = name || email
  return (
    <div className="flex min-w-0 items-center gap-2.5">
      <Avatar className="size-7">
        <AvatarFallback className="bg-accent text-[0.7rem] font-medium text-accent-foreground">{initials(name ?? '', email ?? '')}</AvatarFallback>
      </Avatar>
      <div className="min-w-0 leading-tight">
        <div className="truncate font-medium">{known || 'Unknown account'}</div>
        {name && email ? (
          <div className="truncate text-xs text-muted-foreground">{email}</div>
        ) : !known && uid ? (
          <div className="truncate font-mono text-xs text-muted-foreground">{uid}</div>
        ) : null}
      </div>
    </div>
  )
}
